import { render, staticRenderFns } from "./FinancialRevenues.vue?vue&type=template&id=e00fd65a&scoped=true"
import script from "./FinancialRevenues.vue?vue&type=script&lang=js"
export * from "./FinancialRevenues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00fd65a",
  null
  
)

export default component.exports